<template>
    <ValidationObserver
        ref="labelStatisticsValidation"
        v-slot="{ passes }"
    >
    <v-container 
        class="pt-0 pb-0"
        fluid
        style="background-color: var(--v-listPageBackground-base);"
    >
        <LabelStatisticsCreateNewFavoriteDialog />
        <DeletionDialog :useContextSetinVuex="true" />	
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);">
            <v-col 
                class="headline"
                :alvqa="alvqa + '-list-title'"
            >
                {{ $t('lang_LABEL_STATISTICS')}}
            </v-col>
        </v-row>
        <v-row class="my-0" style="background-color: var(--v-listPageFilterBackground-base);">
            <!-- PRODUCT -->
            <v-col class="py-0">
                <ProductDialog
                    :open="productDialogOpen"
                    :context="context"
                    @close="productDialogOpen = false"
                    v-model="selectedProduct"
                />
            </v-col>
            <!-- SALES TYPE -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'SalesType'"
                    field="SalesType"
                    :hideErrorMessage="false"
                    label="lang_GENERIC_CAPTION_SALES_TYPE"
                    :items="salesTypeValues"
                    :multiple="true"
                    :alvqa="alvqa + '-list-dropdown-sales-types'"
                    rules="required"
                />
            </v-col>
            <!-- ARTIST -->
            <v-col class="py-0">
                <BaseEditPageAutocomplete
                    :context="context"
                    field="Artist"
                    :label="$t('lang_ARTIST')"
                    :withMargin="false"
                    :multiple="false"
                    :withFreeText="false"
                    :isLoading="true"
                    :returnObject="false"
                    rules=""
                    :alvqa="alvqa+'-dropdown-artist'"
                >
                    <template v-slot:selection = "{ item }">
                        {{ $alvPlugin.showNameOfAzEntry(item.artist, true) + ' (' + item.artist.alvId + ')' }}
                    </template>
                    <template v-slot:items="{ items }">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $alvPlugin.showNameOfAzEntry(items.artist, true) + ' (' + items.artist.alvId + ')' }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </v-col>
            <!-- REGIONS -->
            <v-col class="py-0">
                <RegionsDialog :context="context" />
            </v-col>
            <span class="pt-4">
                <BaseIcon/>
            </span>
        </v-row>
        <v-row class="my-0">
            <!-- FROM MONTH -->
            <v-col class="py-0">
                <v-menu
                    ref="fromMonthMenu"
                    min-width="auto"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="fromValue"
                    v-model="fromMonthMenu"
                > 
                    <template v-slot:activator="{ on }">
                        <ValidationProvider 
                            name="toMonth"
                            rules="required|statisticsCheckToFromMonthOrder"
                            v-slot="{ errors }"
                            slim
                        >
                            <v-text-field
                                v-on="on"
                                :value="getFormattedDateFrom"
                                :label="$t('lang_LABEL_STATISTICS_CAPTION_FROM_MONTH')"
                                @click:clear="resetFromValue()"
                                readonly
                                clearable
                                :loading="loading"
                                :alvqa="alvqa + '-textfield-from-month'"
                                :error-messages="errors"
                            ></v-text-field>
                        </ValidationProvider>
                    </template>
                    <v-date-picker
                        v-model="fromValue"
                        :locale="$i18n.locale"
                        color="buttonStandard"
                        no-title
                        type="month"
                        :alvqa="alvqa + '-datepicker-from-month'"
                    >
                        <v-spacer></v-spacer>
                        <BaseButton 
                            class="text-center"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            @click="fromMonthMenu = false"
                            :alvqa="alvqa + '-button-cancel'"
                        />
                        <BaseButton 
                            class="text-center"
                            label="lang_GENERAL_BUTTON_OK"
                            @click="$refs.fromMonthMenu.save(fromValue)"
                            :alvqa="alvqa + '-button-ok'"
                        />
                    </v-date-picker>
                </v-menu>  
            </v-col>
            <!-- TO MONTH -->
            <v-col class="py-0">
                <v-menu
                    ref="toMonthMenu"
                    min-width="auto"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="toValue"
                    v-model="toMonthMenu"
                > 
                    <template v-slot:activator="{ on }">
                        <ValidationProvider 
                            name="fromMonth"
                            rules="required|statisticsCheckToFromMonthOrder"
                            v-slot="{ errors }"
                            slim
                        >
                            <v-text-field
                                v-on="on"
                                :value="getFormattedDateTo"
                                :label="$t('lang_LABEL_STATISTICS_CAPTION_TO_MONTH')"
                                readonly
                                @click:clear="resetToValue()"
                                clearable
                                :loading="loading"
                                :alvqa="alvqa + '-textfield-to-month'"
                                :error-messages="errors"
                            ></v-text-field>
                        </ValidationProvider>
                    </template>
                    <v-date-picker
                        v-model="toValue"
                        :locale="$i18n.locale"
                        color="buttonStandard"
                        no-title
                        type="month"
                        :alvqa="alvqa + '-datepicker-to-month'"
                    >
                        <v-spacer></v-spacer>
                        <BaseButton 
                            class="text-center"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            @click="toMonthMenu = false"
                            :alvqa="alvqa + '-button-cancel'"
                        />
                        <BaseButton 
                            class="text-center"
                            label="lang_GENERAL_BUTTON_OK"
                            @click="$refs.toMonthMenu.save(toValue)"
                            :alvqa="alvqa + '-button-ok'"
                        />
                    </v-date-picker>
                </v-menu>
            </v-col>
            <!-- DISTRIBUTORS -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'Distributors'"
                    field="Distributors"
                    :hideErrorMessage="false"
                    label="lang_LABEL_STATISTICS_IN_ROWS_DISTRIBUTORS"
                    :items="distributorsValues"
                    :alvqa="alvqa + '-list-dropdown-distributors'"
                    :multiple="true"
                    :withMargin="false"
                />
            </v-col>
            <!-- PLATFORMS -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'Platforms'"
                    field="Platforms"
                    :hideErrorMessage="false"
                    label="lang_LABEL_STATISTICS_PLATFORMS"
                    :items="platformsValues"
                    :alvqa="alvqa + '-list-dropdown-platforms'"
                    :multiple="true"
                    :withMargin="false"
                    :allSelect="true"
                />
            </v-col>
            <span class="pt-4">
                <BaseIcon 
                    :alvqa="alvqa + '-list-icon-csv'"
                    @click="exportCsv" 
                    icon="cloud_download" 
                    tooltipText="lang_GENERIC_CAPTION_DOWNLOAD_CSV_REPORT" 
                />
            </span>
        </v-row>
        <v-row class="my-0">
            <!-- Left Chart -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'LeftChart'"
                    field="LeftChart"
                    :hideErrorMessage="false"
                    label="lang_LABEL_STATISTICS_CAPTION_LEFT_CHART"
                    :items="leftChartValues"
                    :alvqa="alvqa + '-list-dropdown-left-chart'"
                    :multiple="false"
                    :withMargin="false"
                    rules="required"
                />
            </v-col>
            <!-- Right Chart -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'RightChart'"
                    field="RightChart"
                    :hideErrorMessage="false"
                    label="lang_LABEL_STATISTICS_CAPTION_RIGHT_CHART"
                    :items="rightChartValues"
                    :alvqa="alvqa + '-list-dropdown-right-chart'"
                    :multiple="false"
                    :withMargin="false"
                    :rules="isRightChartRequired"
                    :disabled="isRightChartEnabled"
                />
            </v-col>
            <!-- Data Table -->
            <v-col class="py-0">
                <DropdownFilter 
                    :context="context + 'DataTable'"
                    field="DataTable"
                    :hideErrorMessage="false"
                    label="lang_LABEL_STATISTICS_CAPTION_DATA_TABLE"
                    :items="dataTableValues"
                    :alvqa="alvqa + '-list-dropdown-data-table'"
                    :multiple="false"
                    :withMargin="false"
                    rules="required"
                />
            </v-col>
            <!-- FAVOURITE -->
            <v-col class="py-0">
                <BaseDropdown 
                    :items="favoriteItems"
                    :label="$t('lang_GENERAL_FAVOURITE')"
                    :context="context+'Favorite'"
                    :hideDetails="true"
                    :returnObject="true"
                    :clearable="true"
                    :item-value="statisticsFavoriteItemValue"
                    :alvqa="alvqa + '-list-favorit-dropdown'"
                />
            </v-col>
            <span class="pt-4">
                <BaseIcon 
                    :alvqa="alvqa + '-list-icon-search'"
                    @click="passes(labelStatisticReport)" 
                    icon="fa-search" 
                    tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
                />
            </span>
        </v-row>
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);" v-if="showChartsSection" class="mt-4">
            <v-col v-if="!showBarChart">
                <pie-chart :context="context + 'First'" ></pie-chart>
            </v-col>
            <v-col cols="10" v-else>
                <bar-chart :context="context" :items="barChartData"></bar-chart>
            </v-col>
            <v-col class="d-flex flex-column">
                <v-row :class="{ 'flex-column': showBarChart }">
                    <v-col class="my-1">
                        <v-card elevation="2" :style="showBarChart ? {} : {maxWidth: '450px'}">
                            <div v-if="cards.firstCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.firstCard.text) ? $t(cards.firstCard.text) : firstCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.getNumberLocalization(cards.firstCard.value, 'number') }} {{  $store.getters.getSelectedCurrency  }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col class="my-1">
                        <v-card elevation="2" :style="showBarChart ? {} : {maxWidth: '450px'}">
                            <div v-if="cards.secondCard" class="d-flex flex-column justify-center align-center" style="height: 100%;">
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.secondCard.text) ? $t(cards.secondCard.text) : cards.secondCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.getNumberLocalization(cards.secondCard.value, 'number').slice(0, -3) }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row v-if="!showBarChart">
                    <v-col class="my-1">
                        <v-card elevation="2" max-width="450">
                            <div v-if="cards.thirdCard" class="d-flex flex-column justify-center align-center" style="height: 100%;" >
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.thirdCard.text) ? $t(cards.thirdCard.text) : cards.thirdCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.getNumberLocalization(cards.thirdCard.value, 'number').slice(0, -3) }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col class="my-1">
                        <v-card elevation="2" max-width="450">
                            <div v-if="cards.fourthCard" class="d-flex flex-column justify-center align-center" style="height: 100%;" >
                                <v-card-title>
                                    {{ $alvPlugin.isLangConst(cards.fourthCard.text) ? $t(cards.fourthCard.text) : cards.fourthCard.text }}
                                </v-card-title>
                                <v-card-text class="text-center">
                                    {{ $alvPlugin.getNumberLocalization(cards.fourthCard.value, 'number').slice(0, -3) }}
                                </v-card-text>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="!showBarChart">
                <pie-chart :context="context + 'Second'"></pie-chart>
            </v-col>
        </v-row>
        <v-row style="background-color: var(--v-listPageHeadlineBackground-base);" v-if="showDataTable">
            <v-col 
                class="headline"
                :alvqa="alvqa + '-data-table-title'"
            >
                {{ $t(dataTableTitle) }}
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="1000"
                    hide-default-footer
                    :header-props="{ sortIcon: '' }"
                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                    class="noMinWidth"
                >
                    <!-- Headers -->
                    <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                        <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                    </template>
                    <!-- Items -->
                    <template v-slot:item="{ item }">
                        <tr>
                            <td> 
                                <span v-if="dataTableTitle === 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_COUNTRIES'">
                                    {{ $alvPlugin.getTranslatedCountryCode(item.title) }}
                                </span>
                                <span v-else-if="dataTableTitle === 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_ARTISTS'">
                                    {{ item.title }}
                                    <span v-if="item.alvId">
                                        (<router-link :to="$alvPlugin.createUrlForAlvId(item.alvId)">{{ item.alvId }}</router-link>)
                                    </span>
                                </span>
                                <span v-else>
                                    {{ item.title }}
                                </span>
                            </td>
                            <td class="no_ellipsis" :alvqa="alvqa + '-list-row-text-artist'" v-if="item.artist !== undefined && item.artist !== null">
                                <BaseTooltip>
                                    <template v-slot:text>{{ item.artist }}</template>
                                    <template v-slot:content>
                                        <span :alvqa="alvqa + '-list-row-text-display-artist'">
                                            {{ item.artist }}
                                        </span>
                                    </template>
                                </BaseTooltip>
                            </td>
                            <td class="no_ellipsis" :alvqa="alvqa + '-list-row-text-isrc'" v-if="item.isrc || item.ean">
                                {{ item.isrc }}
                                {{ item.ean }}
                            </td>
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-quantity'">
                                {{ $alvPlugin.getNumberLocalization(item.quantity, 'number').slice(0, -3) }}
                            </td>
                            <td class="no_ellipsis text-right" :alvqa="alvqa + '-list-row-number-revenue'">
                                {{ $alvPlugin.getNumberLocalization(item.revenue, 'number') }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
    </ValidationObserver>
</template>

<script>

import DropdownFilter from '@/components/_filters/DropdownFilter'
import BaseTooltip from '@/components/_base/BaseTooltip'

import RegionsDialog from '@/components/_dialogs/RegionsDialog'
import ProductDialog from '@/components/_dialogs/ProductDialog'
import LabelStatisticsCreateNewFavoriteDialog from './_dialogs/LabelStatisticsCreateNewFavoriteDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseDropdown from '@/components/_base/BaseDropdown'
import BaseIcon from '@/components/_buttons/BaseIcon'
import PieChart from '@/components/_highcharts/PieChart'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BarChart from '@/components/_highcharts/BarChart.vue'
import { DropdownLabelStatisticsPlatforms, DropdownLabelStatisticsSalesTypes, DropdownLabelStatisticsLeftChart, DropdownLabelStatisticsRightChart, DropdownLabelStatisticsDataTable } from '@/assets/dropdowns/alvDropdowns.js'


export default {
    name: "LabelStatistics",
    components: {
        DropdownFilter,
        BaseTooltip,
        RegionsDialog,
        ProductDialog,
        PieChart,
        LabelStatisticsCreateNewFavoriteDialog,
        DeletionDialog,
        BaseButton,
        BaseDropdown,
        BaseIcon,
        BaseEditPageAutocomplete,
        BarChart
    },
    data() {
        return {
            context: "LabelStatistics",
            alvqa: "label-statistics",
            fromMonthMenu: false,
            toMonthMenu: false,
            productDialogOpen: false,
            selectedProduct: null
        }
    },
    computed: {
        headers(){
            var headers = this.$store.getters.getLabelStatisticsDatatableData.headers
            if(headers.length > 0){
                headers = headers.map((header) => {
                    let textValue = this.$t(header.text)
                    if(header.text == 'lang_LABEL_STATISTICS_CAPTION_REVENUE'){
                        textValue = this.$t(header.text) + ' ' + this.$store.getters.getSelectedCurrency  
                    }
                    return {
                        text: textValue,
                        value: header.value,
                        align: header.align,
                        sortable: header.sortable,
                        class: header.class
                    }
                })
            }
            return headers
        },
        items(){
            return this.$store.getters.getLabelStatisticsDatatableData.data
        },
        showDataTable(){
            if(!this.$store.getters.getLabelStatisticsDatatableData.data || this.$store.getters.getLabelStatisticsDatatableData.data.length == 0){
                return false
            }
            return true
        },
        dataTableTitle(){
            return this.$store.getters.getLabelStatisticsDatatableData.title
        },
        getFormattedDateFrom() { return this.fromValue ? this.$d(new Date(this.fromValue), 'alvMonthYearFormat') : '' },
        getFormattedDateTo() { return this.toValue ? this.$d(new Date(this.toValue), 'alvMonthYearFormat') : '' },
        regions: { 
            get() { return this.$store.getters.getSelectedLabelStatisticsRegionsString },
            set(regions) { this.$store.commit('setSelectedLabelStatisticsRegionsString', regions) }
        },
        fromValue: {
            get() { return this.$store.getters.getSelectedLabelStatisticsFrom },
            set(value) { this.$store.commit('setSelectedLabelStatisticsFrom', value) }
        },
        toValue: {
            get() { return this.$store.getters.getSelectedLabelStatisticsTo },
            set(value) { this.$store.commit('setSelectedLabelStatisticsTo', value) }
        },    
        regions() { 
            let storeIncludes = this.$alvPlugin.getListOfTranslatedCountries()
            storeIncludes.unshift({text: this.$t('lang_CAPTION_REGION_WORLD'), value: 'WORLD'})
            return storeIncludes
        },
        loading: {
            get() { return this.$store.getters.getIsLoading },
            set(value) { this.$store.commit('setIsLoading', value) }
        },  
        favoriteItems() { 
            let dropdownItems = JSON.parse(JSON.stringify(this.$store.getters.getLabelStatisticsFavoriteDropdownValues))
            dropdownItems.forEach(element => {
                // translate "Add favorite" and "Delete favorite" options to selected UI lang
                element['text'] = this.$alvPlugin.isLangConst(element['text']) ? this.$t(element['text']) : element['text']

                // Set alvqas
                if(element.value === 'newFavorite') element['alvqa'] = this.alvqa + '-list-favorit-dropdown-new-favorite'
                else if(element.value === 'deleteFavorite') element['alvqa'] = this.alvqa + '-list-favorit-dropdown-delete-favorite'
                else element['alvqa'] = this.alvqa + '-list-favorit-dropdown-' + element['id']
            })
            return dropdownItems
        },
        distributorsValues() {
            let distributors = this.$store.getters.getLabelStatisticsInRowsDistributors
            distributors = distributors.filter(
                (distributor) =>
                    distributor &&
                    distributor.text &&
                    !distributor.text.startsWith("All Users of Type=End user")
            ).map((distributor) => {
                return{
                    text: distributor.text + ' ('+distributor.alvid+')',
                    value: distributor.alvid
                }
            })
            return distributors
        },
        salesTypeValues() {
            return DropdownLabelStatisticsSalesTypes.map((type) => {
                return {
                    text: this.$t(type.text),
                    value: type.value
                }
            })
            
        },
        platformsValues() {
            return DropdownLabelStatisticsPlatforms.map((platform) => {
                return {
                    text: this.$t(platform.text),
                    value: platform.value
                }
            })
        },
        leftChartValues(){
            return DropdownLabelStatisticsLeftChart
        },
        rightChartValues(){
            return DropdownLabelStatisticsRightChart
        },
        dataTableValues(){
            return DropdownLabelStatisticsDataTable
        },
        showChartsSection(){
            return this.$store.getters.getShowLabelStatisticsChartsSection;
        },
        cards(){
            return this.$store.getters.getLabelStatisticsCards
        },
        isRightChartRequired(){
            let leftChartSelectedOption = this.$store.getters.getSelectedLabelStatisticsLeftChart
            if( leftChartSelectedOption === 'byMonths' || leftChartSelectedOption === 'byMonthsAndPreviousYear'){
                this.$store.commit('setSelectedLabelStatisticsRightChart', null)
                return ''
            }
            return 'required'
        },
        isRightChartEnabled(){
            let leftChartSelectedOption = this.$store.getters.getSelectedLabelStatisticsLeftChart
            if(leftChartSelectedOption === 'byMonths' || leftChartSelectedOption === 'byMonthsAndPreviousYear'){ return true }
            return false
        },
        showBarChart(){
            return this.$store.getters.getShowLabelStatisticsBarChart
        },
        barChartData(){
            return this.$store.getters.getLabelStatisticsBarChart
        }
    },
    methods: {
        statisticsFavoriteItemValue(item) {
            return item.id != null ? item.id : item.value
        },
        filter() {
            this.$store.dispatch('fetchLabelStatistics')
        },
        resetFromValue(){
            this.$store.commit("setSelectedLabelStatisticsFrom",null)
        },
        resetToValue(){
            this.$store.commit("setSelectedLabelStatisticsTo",null)
        },
        exportExcel() {
            let fromDate = this.$store.getters.getSelectedLabelStatisticsFrom
            let toDate = this.$store.getters.getSelectedLabelStatisticsTo

            if(fromDate === null || toDate === null || (fromDate === null && toDate === null)){
                this.$store.commit('setSnackbar', { 
                    type: 'error', 
                    msg: this.$t('lang_GENERAL_CAPTION_PLEASE_SELECT_PERIOD')
                })
                
            }else{
                this.$store.dispatch('labelStatisticsExportExcel')
            }
        },
        labelStatisticReport(){
            this.$store.dispatch('labelStatisticReport')
        },
        async exportCsv(){
            let fromMonth = await this.$refs['labelStatisticsValidation'].refs.toMonth.validate()
            let toMonth = await this.$refs['labelStatisticsValidation'].refs.fromMonth.validate()
            let dataTable = await this.$refs['labelStatisticsValidation'].refs.DataTable.validate()
            let salesType = await this.$refs['labelStatisticsValidation'].refs.SalesType.validate()
            if(fromMonth.valid == false || toMonth.valid == false || salesType.valid === false || dataTable.valid === false) return
            this.$store.dispatch('labelStatisticExportCsv')
        }
    },
    created() {
        this.$store.commit('setCountries')
        this.$store.commit('setLabelStatisticsInRows')
        this.$store.dispatch('fetchLabelStatisticsFavoriteDropdownValues')
    }    
}
</script>